'use strict';

module.exports = {

    returnDeviceType: function returnDeviceType() {

        var isMobile = {
            Android: function Android() {
                return window.navigator.userAgent.match(/Android/i) ? 'android' : '';
            },
            iOS: function iOS() {
                return window.navigator.userAgent.match(/iPhone|iPad|iPod/i) ? 'ios' : '';
            },
            any: function any() {
                return isMobile.Android() || isMobile.iOS();
            }
        };

        var type;
        switch (isMobile.any()) {
            case 'android':
                {
                    type = 'android';
                    break;
                }
            case 'ios':
                {
                    type = 'ios';
                    break;
                }
            default:
                {
                    type = 'desktop';
                }
        }
        return type;
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/mobileBrowserHelper.js
// module id = 849
// module chunks = 0